<template>
  <div class="max-w-screen-xl xl:px-8 p-4 mx-auto mt-8">
    <div class="grid grid-cols-12 gap-3">
      <div
        v-for="widget in widgets"
        @click="openPreview(widget)"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <span
            v-if="checkTag(widget.type_explore.id) == 'hot'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-1 bg-red-500 text-white font-medium text-xs"
          >
            Hot
          </span>
          <span
            v-if="checkTag(widget.type_explore.id) == 'new'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-0.5 bg-success text-white font-medium text-xs"
          >
            New
          </span>
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              {{ widget.type_explore.title }}
            </h2>
            <img
              :src="
                'https://app.qrgateway.com/explores/' + widget.type_explore.icon
              "
              class="w-12 ml-auto"
              :alt="widget.type_explore.title"
            />
          </div>
          <p class="mt-4 sr-only">{{ widget.type_explore.description }}</p>
        </div>
      </div>
      <div
        @click="openLinkBuilder"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              Page Builder
            </h2>
            <img
              src="/icons/builder.svg"
              class="w-12 ml-auto"
              :alt="'page-builder'"
            />
          </div>
        </div>
      </div>
    </div>
    <template v-if="widget_select">
      <PreviewWidgetDialog :widget="widget_select" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useQrCreateStore } from "~~/stores/qrcreate";
import PreviewWidgetDialog from "../partials/PreviewWidgetDialog.vue";

interface ExploreType {
  type_explore: {
    id: number;
    title: string;
    description: string;
    group_explore_id: number;
    icon: string;
    status: number;
    full_widget: number;
  };
  name: string;
  image: string;
  uuid: string;
  slug: string;
}
const res = await useAsyncData(async () => {
  const res = await $fetch("/api/widget");
  return res as ExploreType[];
});
const widgets = res.data.value as ExploreType[];
const checkTag = (id: number) => {
  const news = [36, 37, 38, 39, 40, 41, 42, 43, 44];
  const hots = [15, 29, 17];
  if (news.includes(id)) {
    return "new";
  }
  if (hots.includes(id)) {
    return "hot";
  }
  return "";
};
const { preview_widget_modal } = storeToRefs(useQrCreateStore());
const widget_select = ref<ExploreType | null>(null);
const { redirectUrl } = useUtils();
const openPreview = (widget: ExploreType) => {
  if (typeof window !== "undefined") {
    const screen = window.innerWidth;
    if (screen < 768) {
      const url =
        "https://app.qrgateway.com/sign-up?createSample=" + widget.uuid;
      redirectUrl(url);
      return;
    }
  }
  widget_select.value = widget;
  if (widget_select.value) {
    preview_widget_modal.value = true;
  }
};

const openLinkBuilder = () => {
  redirectUrl("https://app.qrgateway.com/page-builder");
};
</script>
